import {Link, Outlet} from "react-router-dom";
import {useLookReset} from "../hooks/useLookReset";
import {appVersion} from "../shared/utils/version";
import Header from "./Header";

// Shared chrome for every authenticated page; add new routes as children
// of the ProtectedRoute in routes/index.jsx to get the header.
const ProtectedLayout = () => {
    useLookReset();
    const version = appVersion();
    return (
        <>
            <Header />
            <Outlet />
            {version && (
                <footer className="text-center small pb-3">
                    <Link to="/changelog" className="text-muted">
                        Ordo v{version}
                    </Link>
                </footer>
            )}
        </>
    );
};

export default ProtectedLayout;
